import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
// import F from './components/F';
import G from './components/G';
import H from './components/H';
import { useGlobal } from '@/utils/useGlobal';

export default function IndexDynamic() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('corporatesocialresponsibility');
    const [activeTab, setActiveTab] = useState(0);
    const [top, setTop] = useState(0);

    const goTo = (cls: string, n: number) => {
        setActiveTab(n);
        const target = document.querySelector(`.csr ${cls}`) as HTMLDivElement;
        target.scrollIntoView({
            behavior: 'smooth',
        });
    };

    const observeFn = (cls: string, n: number) => {
        // 获取目标元素
        const targetElement = document.querySelector(cls) as HTMLElement;

        // 创建一个IntersectionObserver实例
        const observer = new IntersectionObserver((entries) => {
            // 遍历所有观察的目标元素
            entries.forEach((entry) => {
                // 如果目标元素进入视口
                if (entry.isIntersecting) {
                    setActiveTab(n);
                    // 停止观察目标元素
                    // observer.unobserve(targetElement);
                } else {
                    // 离开视口
                    if (![0, 2].includes(activeTab)) setActiveTab(0);
                }
            });
        });

        // 开始观察目标元素
        observer.observe(targetElement);
    };

    useEffect(() => {
        observeFn('.csr-C', 0);
        observeFn('.csr-D', 1);
        observeFn('.csr-E', 2);

        if (typeof window !== 'undefined') {
            const bar = document.querySelector('.announcement-bar') as HTMLElement;
            if (bar) {
                const styles = window.getComputedStyle(bar);
                const position = styles.position;
                if (bar && position === 'sticky') {
                    setTop(bar?.offsetHeight);
                }
            }
        }
    }, []);

    return (
        <>
            <B />
            <div className="big-wrapper">
                <div className="sticky-tab" style={{ top: `${top}px` }}>
                    <span className={`tab-item ${activeTab === 0 ? 'active' : ''}`} onClick={() => goTo('.csr-C', 0)}>
                        {t('secC_tab1')}
                    </span>
                    <span className={`tab-item ${activeTab === 1 ? 'active' : ''}`} onClick={() => goTo('.csr-D', 1)}>
                        {t('secC_tab2')}
                    </span>
                    <span className={`tab-item ${activeTab === 2 ? 'active' : ''}`} onClick={() => goTo('.csr-E', 2)}>
                        {t('secC_tab3')}
                    </span>
                </div>
                <C />
                <D />
                <E />
                {['cn', 'jp', 'eu', 'de', 'fr', 'it', 'es', 'us', 'ca', 'za', 'au', 'uk', 'mx', 'nl'].includes(locale) && <H />}
            </div>
            {/* <F /> */}
            <G />
        </>
    );
}
